var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnePageFirstStyleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2844_4985)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 72,
    height: 72,
    rx: 8,
    fill: "url(#paint0_linear_2844_4985)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2844_4985)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 17.5,
    r: 22.5,
    fill: "#5AFFA6",
    fillOpacity: 0.15
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 62,
    r: 1,
    fill: "#0FDC8D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 59,
    r: 18,
    fill: "#0FDC8D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 11,
    r: 19,
    fill: "#8EB5F0",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 30.5,
    r: 11.5,
    fill: "#8EB5F0",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 53,
    r: 7.5,
    stroke: "#5383FF",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 51,
    r: 12,
    fill: "#FFCFC8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 32.5,
    r: 20.5,
    fill: "#0FDC8D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 35,
    r: 4.5,
    stroke: "#0FDC8D"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 71,
    height: 71,
    rx: 7.5,
    stroke: "#DBDADE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2844_4985",
    x: -16.5,
    y: -20,
    width: 75,
    height: 75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_2844_4985"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2844_4985",
    x1: 1.275,
    y1: 36,
    x2: 72.5147,
    y2: 36.6268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0FFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2F5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2844_4985"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 72,
    height: 72,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnePageFirstStyleIcon);
export default __webpack_public_path__ + "static/media/OnePageFirstStyleIcon.32f84d692d5ad14e6f0e7852bbf3ff72.svg";
export { ForwardRef as ReactComponent };